import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from 'app/core';
import {TrackingPageFacade} from '../../store/tracking-page';
import {filter} from 'rxjs/operators';
import {DestroyChecker} from 'app/helpers';

@Component({
  selector: 'app-tracking-page-root',
  templateUrl: './tracking-page-root.component.html',
  styleUrls: ['./tracking-page-root.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TrackingPageRootComponent extends DestroyChecker {
  constructor(
    translate: TranslateService,
    private storageService: StorageService,
    private trackingPageFacade: TrackingPageFacade,
  ) {
    super();

    trackingPageFacade.trackingPage$
      .pipe(filter(trackingPage => trackingPage && trackingPage.languageMenu))
      .subscribe(trackingPage => {
        const storedLang = this.storageService.getItem('selectedLocale');
        const currentLang = storedLang || trackingPage?.languageMenu?.defaultLan || 'en';
        if (currentLang !== storedLang) {
          this.storageService.setItem('selectedLocale', currentLang);
        }
        translate.use(currentLang);
      });
  }
}
